/**
 * DataCard primitive — uniform-height card for displaying attraction, visit, or trip data.
 * Uses Tailwind design tokens — no hardcoded hex colors.
 */
import React from 'react';

export interface DataCardProps {
  title: string;
  subtitle?: string;
  children?: React.ReactNode;
  className?: string;
}

export function DataCard({ title, subtitle, children, className }: DataCardProps): React.ReactElement {
  return (
    <div
      className={`
        h-[120px] min-h-[120px] flex flex-col rounded-xl bg-white dark:bg-surface-dark-card p-5 shadow-card dark:ring-1 dark:ring-white/[0.06]
        hover:shadow-card-hover transition-all duration-200
        ${className ?? ''}
      `}
    >
      <div className="flex items-start justify-between mb-3">
        <div>
          <h3 className="text-lg font-bold text-gray-900 dark:text-gray-100">{title}</h3>
          {subtitle && (
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-0.5">{subtitle}</p>
          )}
        </div>
      </div>
      {children && <div className="mt-2">{children}</div>}
    </div>
  );
}
